const appHeaderStyles = { fontFamily: 'Raleway,Helvetica,Arial,sans-serif' }
const linkButtonStyles = { padding: 8 }
const burgerMenuIconStyles = { marginLeft: 8 }

export default () =>
  Object.freeze({ appHeaderStyles, linkButtonStyles, burgerMenuIconStyles })
